import * as types from "./actions";
import { FIELD_PRODUCT_ORDER } from '../../../../utils/constants';

const defaultState = {
    list: [],
    tableHeader: [
        {
            label: "商品分類",
            center: true,   
        },
        {
            label: "商品コード",
            center: true,   
            rightAlign: true
        },
        {
            label: "商品名１",
            center: true,   
        },
        {
            label: "商品名２",
            center: true,   
        },
        {
            label: "受注商品",
            center: true,   
            rightAlign: true
        },
        {
            label: "金額",
            center: true,   
            rightAlign: true
        },
    ],
    tableColumns: [
        "productTypeName",
        "productCode",
        "productName1",
        "productName2",
        FIELD_PRODUCT_ORDER,
        "totalAmount"
    ],

}

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.LIST:
            return { ...state, list: action.payload };
        default: // need this for default case
            return state
    }
};
